import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';

export default function HourglassIcon(props) {
  return <HourglassBottomIcon {...props} className="spin" />
}
